import { CircularProgress, Paper, TableCell, TableContainer, TableHead, TableRow, Table, TableBody, Button, Alert, Snackbar } from "@mui/material"
import KwilDB from "kwildb"
import { useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import { useDispatch, useSelector } from "react-redux"
import ShadowScrollbars from "../assets/shadowScrollbars"
import "../styling/Home.css"
import AddRow from "./modifyTable-components/AddRow"
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { removeInput, resetInput } from "../redux/slices/newRowSlice"
import { resetIndex } from "../redux/slices/newRowIndexSlice"
import DbCell from "./modifyTable-components/DbCell"
import { resetCellEdit } from "../redux/slices/cellEditSlice"
import { resetCellEditIndex } from "../redux/slices/cellEditIndex"
import { resetEditColumn } from "../redux/slices/cellEditColumn"


export default function TableView({ tableName, schemaName, privKey, secret }) {
    const [loading, setLoading] = useState(false)
    const [cols, setCols] = useState([])
    const [rows, setRows] = useState([])
    const [addRow, setAddRow] = useState(false)
    const [height, setHeight] = useState(window.innerHeight*.8)
    const [varType, setVarType] = useState([])
    const [submit, setSubmit] = useState(0)
    const [refresh, setRefresh] = useState(0)
    const [submitEdit, setSubmitEdit] = useState(0)
    const [errMsg, setErrMsg] = useState("")
    const [editMode, setEditMode] = useState(false)

    const dispatch = useDispatch()

    const moatName = useSelector((state) => state.loadedMoat.value)
    const newRowInputs = useSelector((state) => state.newRow.cellInputs)
    const newRowColIndex = useSelector((state) => state.newRowIndex.colIndex)
    const cellEdit = useSelector((state) => state.cellEdit.edit)
    const cellEditIndex = useSelector((state) => state.cellEditIndex.editIndex)
    const cellEditColumn = useSelector((state) => state.cellEditColumn.editColumn)

    useEffect(() => {
        let filter = ""
        if(cols.includes("row_id")) {
            filter = " ORDER BY row_id ASC"
        }

        setLoading(true)
        setTimeout(async function () {
            const kwilDB = KwilDB.createConnector(
                {
                    host: "test-db.kwil.xyz",
                    protocol: "https",
                    port: null,
                    moat: moatName,
                    privateKey: JSON.parse(privKey)
                },
                secret
            )
            let result = await kwilDB.query(`SELECT * FROM ${schemaName}.${tableName}${filter}`)
            if(filter ==="" && result.fields[0].name === "row_id") {
                result = await kwilDB.query(`SELECT * FROM ${schemaName}.${tableName} ORDER BY row_id ASC`)
            }
            let columns = []
            for (let i = 0; i < result.fields.length; i++) {
                columns.push(result.fields[i].name)
            }
            setCols(columns)
            setRows(result.rows)
            setLoading(false)
        })
    }, [tableName, schemaName, refresh])

    useEffect(() => {
        setTimeout(async function () {
            const kwilDB = KwilDB.createConnector(
                {
                    host: "test-db.kwil.xyz",
                    protocol: "https",
                    port: null,
                    moat: moatName,
                    privateKey: JSON.parse(privKey)
                },
                secret
            )
            const result = await kwilDB.query(`SELECT table_name, column_name, data_type FROM information_schema.columns WHERE table_name = '${tableName}'`)
            let dataType = []
            for(let i = 0; i < result.rows.length; i++) {
                dataType.push(result.rows[i].data_type)
            }
            setVarType(dataType)
        })
    }, [tableName, schemaName])

    function createColString() {
        let colString = ""
        for(let i = 0; i < newRowColIndex.length; i++) {
            let index = newRowColIndex[i]
            colString += cols[index] + ", "
        }
        return colString.slice(0, -2)
    }

    function createInputString() {
        let inputString = ""
        for(let i = 0; i < newRowInputs.length; i++) {
            inputString += `'${newRowInputs[i]}'` + ", "
        }
        return inputString.slice(0, -2)
    }

    function executeAddRow(e) {
        setLoading(true)
        const finalCol = createColString()
        const finalInput = createInputString()
        setTimeout(async function () {
            const kwilDB = KwilDB.createConnector(
                {
                    host: "test-db.kwil.xyz",
                    protocol: "https",
                    port: null,
                    moat: moatName,
                    privateKey: JSON.parse(privKey)
                },
                secret
            )
            try {
                await kwilDB.query(`INSERT INTO ${schemaName}.${tableName} (${finalCol}) VALUES (${finalInput})`, true)
            } catch (error) {
                setErrMsg("Double check that the inputs you submitted match the selected Postgres variable types.")
            }
            setLoading(false)
            setAddRow(false)
            setRefresh(refresh + 1)
        })
    }
    
    function generateSqlUpdate() {
        let editObjects = []

        for (let i = 0; i < cellEdit.length; i++) {
            let obj = {
                cellEdit: cellEdit[i],
                cellEditIndex: cellEditIndex[i],
                cellEditColumn: cellEditColumn[i]
            }
            editObjects.push(obj)
        }
    
        let objectForSql = new Map()

        for (let i = 0; i < editObjects.length; i++) {
            if(objectForSql.has(editObjects[i].cellEditIndex)) {
                let obj = objectForSql.get(editObjects[i].cellEditIndex)
                if(Array.isArray(obj)) {
                    obj.push({
                        cellEdit: editObjects[i].cellEdit,
                        cellEditColumn: editObjects[i].cellEditColumn,
                        cellEditIndex: editObjects[i].cellEditIndex
                    })
                } else {
                objectForSql.assign(editObjects[i].cellEditIndex, [{
                    cellEdit: editObjects[i].cellEdit,
                    cellEditColumn: editObjects[i].cellEditColumn,
                    cellEditIndex: editObjects[i].cellEditIndex
                }])
            }
        } else {
            objectForSql.set(editObjects[i].cellEditIndex, [{
                cellEdit: editObjects[i].cellEdit,
                cellEditColumn: editObjects[i].cellEditColumn,
                cellEditIndex: editObjects[i].cellEditIndex
            }])
        }}
        
        const arrayForSql = Array.from(objectForSql.values())

        let sqlString = ""

        for (let i = 0; i < arrayForSql.length; i++) {
            let col = ""
            for (let j = 0; j < arrayForSql[i].length; j++) {
                col += `${arrayForSql[i][j].cellEditColumn} = '${arrayForSql[i][j].cellEdit}', `
            }
            col = col.slice(0, -2)

            sqlString += `
                UPDATE ${schemaName}.${tableName}
                SET ${col}
                WHERE row_id = '${arrayForSql[i][0].cellEditIndex}';`
        }
       
        setLoading(true)

        setTimeout(async function () {
                    try {const kwilDB = KwilDB.createConnector(
                    {
                        host: "test-db.kwil.xyz",
                        protocol: "https",
                        port: null,
                        moat: moatName,
                        privateKey: JSON.parse(privKey)
                    },
                    secret
                )
                await kwilDB.query(sqlString, true)
                setLoading(false)
            
        } catch (error) {
            setLoading(false)
            setErrMsg("Double check that variables submitted match required variable")
        }
        setRefresh(refresh + 1)
    })
        
        setEditMode(false)
    }

    return(
        <div className="table-view">
            {tableName !== "" ? (
                <Helmet>
                    <title>{tableName} | {moatName} | KwilDB</title>
                </Helmet>
            ) : <></>}
            <div style={{ display: "grid", gridTemplateColumns: "50% 50%", width: "100%" }}>
                <p className="table-title">{tableName}</p>
                <div style={{ display: "flex", gridColumn: "2"}}>
                    {editMode ? 
                        <Button
                        sx={{
                            width: "110px",
                            height: "40px",
                            background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                            opacity: ".9",
                            color:  "#fff",
                            borderRadius: "10px",
                            fontFamily: "Averta",
                            fontSize: "14px",
                            lineHeight: "23px",
                            fontWeight: "bold",
                            margin: "auto 20px 0 auto",
                            gridColumn: "2"
                        }}
                        onMouseEnter={() => {
                            dispatch(resetCellEdit())
                            dispatch(resetCellEditIndex())
                            dispatch(resetEditColumn())
                            setSubmitEdit(submitEdit + 1)
                        }}
                        onClick={generateSqlUpdate}
                        >
                            Confirm
                        </Button> : <></>
                    }
                    <Button
                        sx={{
                            width: "110px",
                            height: "40px",
                            background: editMode ? "linear-gradient(90deg, #95FF7A 0%, #9DFF70 100%)" : "linear-gradient(90deg, #FF624D 0%, #FA746B 100%)",
                            opacity: ".9",
                            color: editMode ? "#000" : "#fff",
                            borderRadius: "10px",
                            fontFamily: "Averta",
                            fontSize: "14px",
                            lineHeight: "23px",
                            fontWeight: "bold",
                            margin: editMode ? "auto 70px 0 0" : "auto 70px 0 auto",
                            gridColumn: "2"
                        }}
                        onClick={() => {if(cols.includes("row_id")) {
                            editMode ? setEditMode(false) : setEditMode(true)
                        } else {
                            setErrMsg("Table is missing row_id column! Please add the column in your IDE before editing.")
                        }
                        }}
                    >
                        Edit {editMode ? "ON" : "OFF"}
                    </Button>
                </div>
            </div>
            <CircularProgress
                sx={{
                    display: loading ? "flex" : "none",
                    margin: "300px auto",
                    color: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)"
                }}
            />
            <TableContainer
                sx={{
                    display: loading ? "none" : "inline",
                    borderRadius: "5px",
                    maxWidth: "calc(100vw - 350px)",
                    height: `100%`,
                    backgroundColor: "transparent",
                    margin: "30px 40px 0px"
                }}
                component={Paper}
            >
                <ShadowScrollbars
                    autoHeight
                    autoHeightMin={0}
                    autoHeightMax={height}
                >
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {cols.map((column, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{ color: "#fff", borderBottom: "none", background: "#1C407C", width: `${(1/cols.length) * 100}%` }}
                                    >
                                        {column}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody
                            sx={{
                                backgroundColor: "transparent",
                                borderRadius: "0 0 5px 5px",
                            }}
                        >
                            {rows.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{
                                        "&:last-child td, &:last-child th": {
                                            border: 0,
                                        },
                                        "&:hover": {
                                            backgroundColor: editMode ? "rgba(122, 122, 122, 0.8)" : ""
                                        },
                                        backgroundColor: index % 2 === 0 ? "#141235" : "rgb(21, 21, 21, 0.2)"
                                    }}
                                >
                                    {cols.map((column, index) => (
                                        <DbCell
                                            index={index}
                                            row={row}
                                            column={column}
                                            editMode={editMode}
                                            submitEdit={submitEdit}
                                            varType={varType}
                                            setErrMsg={setErrMsg}
                                        />
                                    ))}
                                </TableRow>
                            ))}
                            {addRow ? 
                                <TableRow>
                                {cols.map((column, index) => (
                                    <AddRow     
                                        index={index}
                                        column={column}
                                        varType={varType[index]}
                                        submit={submit}
                                        rows={rows}
                                        setErrMsg={setErrMsg}
                                    /> 
                                ))}
                                </TableRow>
                         : <></>}
                        </TableBody>
                    </Table>
                    {!addRow ? 
                        <Button
                            sx={{
                                width: "110px",
                                height: "40px",
                                margin: "25px 0 0 0",
                                background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                                opacity: ".9",
                                color: "#fff",
                                borderRadius: "10px",
                                fontFamily: "Averta",
                                fontSize: "14px",
                                lineHeight: "23px",
                                fontWeight: "bold"
                            }}
                            onClick={() => setAddRow(true)}
                        >
                            Add Row
                        </Button> : <></>
                    }
                    {addRow ?
                        <div style={{display: "flex"}}>
                            <Button
                                sx={{
                                    width: "30px !important",
                                    height: "30px",
                                    marginTop: "25px",
                                    background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                                    opacity: ".9",
                                    color: "#fff",
                                    borderRadius: "10px",
                                    minWidth: "0"
                                }}
                                onClick={executeAddRow}
                                onMouseEnter={() => {
                                    dispatch(resetInput())
                                    dispatch(resetIndex())
                                    setSubmit(submit + 1)
                                }}
                            >
                                <CheckIcon />
                            </Button>
                            <Button
                                sx={{
                                    width: "30px !important",
                                    height: "30px",
                                    marginTop: "25px",
                                    marginLeft: "13px",
                                    background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                                    opacity: ".9",
                                    color: "#fff",
                                    borderRadius: "10px",
                                    minWidth: "0"
                                }}
                                onClick={() => setAddRow(false)}
                            >
                                <CloseIcon />
                            </Button>
                        </div>
                        : <></>
                    }
                </ShadowScrollbars>
            </TableContainer>
            <Snackbar
                sx={{ margin: "0px auto" }}
                open={errMsg}
                autoHideDuration={4000}
                onClose={() => setErrMsg("")}
            >
                <Alert
                    variant="filled"
                    severity="error"
                    sx={{ width: "100%" }}
                    onClose={() => setErrMsg("")}
                >
                    {errMsg}
                </Alert>
            </Snackbar>
        </div>
    )
}